export default "__VITE_ASSET__D4wL8RQn__"